export const isAndroidFirefox = (): boolean =>
  typeof navigator !== 'undefined' && /android.*firefox/i.test(navigator.userAgent)
